import { useContext, useEffect, useState } from "react";
import { SocketContext } from "../../contexts/SocketContext";

export const useTurnos = (payload) => {

    const [turnos, setTurnos] = useState([]);
    const [total, setTotal] = useState(0);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        let subscribed = true;

        const obtenerTurnos = () => {
            socket.emit('frontend:obtener-turnos', payload, response => {
                const { ok, total, data } = response;

                if(!ok) return;
       
                setTurnos(data);
                setTotal(total);
            });
        }

        subscribed && obtenerTurnos();

        return () => {
            subscribed = false;
            socket.off('frontend:obtener-turnos');
        }
    }, []);

    return {
        turnos,
        total
    }
}